import * as types from "./mutation-type";
import { getModulesQuery,getStoreModulesQuery } from "./queries.graphql";
import gqlClient from "@/modules/graphql";
import api from "@/modules/api";

const actions = {
  async getModules({ commit }, variables = {}) {
    try {
      commit(types.GET_MODULES_BEGIN);
      const {
        data: {
          data: {
            system: {
              modules
            }
          }
        }
      } = await gqlClient.query({
        query     : variables.isStore ? getStoreModulesQuery : getModulesQuery,
        variables : variables
      });
      commit(types.GET_MODULES_SUCCESS, modules);
    } catch (e) {
      commit(types.GET_MODULES_ERROR, e);
    }
  },
  async createModule({ commit }, variables ) {
    try {
      commit(types.CREATE_MODULE_BEGIN)
      const { data  }  = await api.moduleLog.createModuleLog( variables )
      commit(types.CREATE_MODULE_SUCCESS,data)

    } catch (e) {
      commit(types.CREATE_MODULE_ERROR, e)
    }
  },
  async updateCompanyModule({ commit }, variables) {
    try {
      commit(types.UPDATE_COMPANY_MODULE_BEGIN);
      const { data  }  = await api.moduleLog.updateModuleLog(variables);
      
      commit(types.UPDATE_COMPANY_MODULE_SUCCESS, data);
    } catch (e) {
      commit(types.UPDATE_COMPANY_MODULE_ERROR, e);
    }
  },
  async createStoreModule({ commit }, variables ) {
    try {
      commit(types.CREATE_STORE_MODULE_BEGIN)
      const { data  }  = await api.storeModuleDisabled.createStoreModuleDisabled( variables )
      commit(types.CREATE_STORE_MODULE_SUCCESS,data)

    } catch (e) {
      commit(types.CREATE_MODULE_ERROR, e)
    }
  },
  async deleteStoreModule({ commit }, id) {
    try {
      commit(types.DELETE_STORE_MODULE_BEGIN);
      await api.storeModuleDisabled.deleteStoreModuleDisabled(id);

      commit(types.DELETE_STORE_MODULE_SUCCESS);
    } catch (e) {
      commit(types.DELETE_STORE_MODULE_ERROR, e);
    }
  },
};

export default actions;
